'use client';

import { formErrorAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyleText = defineStyle({
  color: 'text/alert',
  // eslint-disable-next-line no-warning-comments
  // TODO:
  // The same styling here for fontSize and lineHeight are defined in
  // theme.textStyles.body.regular, and can be used by setting the textStyle property to 'body.regular'.
  // However, following that approach, there is an issue with the styling not being applied.
  fontSize: 'regular',
  lineHeight: 1.5
});

const baseStyle = definePartsStyle({
  text: baseStyleText
});

export const formErrorTheme = defineMultiStyleConfig({
  baseStyle
});
